<template>
<div class="page_tixian">
	<!-- 银行卡 -->
	<div class="card" @click="showBankPicker = true">
		<div class="card_l" v-if="selectBank">
			<!-- <img src="" alt="" class="card_icon"> -->
			<div class="card_info">
				<div class="card_type">{{ selectBank.bank_name }}</div>
				<div class="card_num">{{ selectBank.card_no }}</div>
			</div>
		</div>
        <div class="card_l" v-else>
			<div class="user">请选择银行卡</div>
		</div>
	</div>
    <!-- 提现类型 -->
	<div class="tixian">
		<div class="tixian_top">
			<div class="name">园区余额</div>
			<div class="action">{{ '¥'+ allPrice }}</div>
		</div>
	</div>
	<!-- 提现 -->
	<div class="tixian">
		<div class="tixian_top">
			<div class="name">提现金额</div>
			<div class="action" @click="clickAllPrice">全部提现</div>
		</div>
		<!-- 余额 -->
		<div class="balance">
			<div class="balance_t">
				<span class="tag_cash">¥</span>
				<van-field v-model="cash" type="number" placeholder="请输入提现金额" class="cash_field"/>
			</div>
			<div class="balance_b">
				<div class="tips_balance">可用余额<span class="price"><span class="tag_price">¥</span>{{ allPrice }}</span></div>
				<div class="tips_fee">*提现每笔1元</div>
			</div>
		</div>
	</div>
	<!-- 确认提现 -->
	<van-button block :loading="submitLoading" class="big_btn" @click="withdraw">确认提现</van-button>
	<!-- 提现规则 -->
	<div class="guize" @click="goPage">提现规则</div>
	<!-- 选银行卡 -->
	<van-popup v-model="showBankPicker" position="bottom">
		<van-picker
			show-toolbar
			:columns="bankList"
			value-key="card_no"
			@cancel="showBankPicker = false"
			@confirm="onConfirmBank"
		/>
	</van-popup>
	<!--  -->
	<div v-html="paypwdForm" id="paypwdForm" style="position:absolute; top:-9999em; left:-9999em;"></div>
	<!-- <form id="rongpaysubmit" name="rongpaysubmit" action="https://api.reapal.com/member/custmemwithdraw/withdraw" method="post">
		<input type="hidden" name="merchant_id" value="100000001306218"/>
		<input type="hidden" name="data" value="aN/JToWLnhuTm3HkVLW/QUQyzDUe25WfrF5+dSdTmh/EBDKYc3gWAiQ28A0WVWJveCq1Wlx+g7ypkaP2Ubx1JJY4k+zmabi39034OuLepT6hLfH0lRZLT75eunzkBIk8Ncvdc26WapQ/JMPxtR8iAsWpHcDu584M6inIxOl3ahLknkbcMNx33xvXbHPKfbkxh6yPpSWibULhvP+Lsd1lLIIum0Z9TMNDI6KDgZB0+JSFdwvRI4tlHRTD7XyXuRTEGk0qsMwmbiR3gCl77I6Y6zD5zL31jQnP62ejivvPIC8+Ab0JM3n827+yCUYQgDdGHFig+uGyCgvXya9skZtbNUEdu9PSInas153yGezlRnziNPfv5FyXQOozWtQKWuQbglWDfuBZq66E8YM0svd5lLOGH3Um5oOxw1xB/t14a1ep4bkDH9nzJdNdJEu0ZLz4U1cbCLO+6IS1qNG0GbXjWreIEfzR9gmB1y0VMdNAaAjk7HxQSwugp3b43wbZL1nSkh2ruiET8Bfq3H2LD70F8frvRSZMikTpOj8CR5MIFR3eQ4lSU3Pu77jtSNRlS0pGtIGd5lzialn4tpawUBKhuEgIm1b9jMmEyHCQ9pKh68khMFdNV42M+Ln4Nt5GPE6riwRpMHJHq5tRtCUEuG68p3eBFSphNH/D6tIxgtSp+1F3pCeF6k6Jcvhy2b6OYbprmzrzlFGPjvh8spGMkRfwBAyOYNne07d33LFdUuKdsM7OOPKL6RaCBLHPzqvxg+1Tj9LTfAT9d/3mVTKjBhJdoaPtbOUk53+2wjmNC17kyVW1p21gyZQh6u2pKlhraUXKgM6ez/pIxammF3b5QQLBmy1hdzhzLi6I/i1ltfgKL5MDYHtstgRvaAnMCFB3+tTw"/>
		<input type="hidden" name="encryptkey" value="f950xLnVVi2WpwRkmtLVnKrFXOGGZTobNMOsa+K4e8eyfLJyZzpFC8e+wTTF0HRVvAWjGUXIeABQ8X7qgvlrJ3lBO9/omxCCqT2qR9Vw3jmtYkc59KJ4XWtNQULkqVDlw4tXrhfsFqa9EWza2fUVg/7meCXo2t9BatsSguegHSTHJrs8ncRIRm7f2JpZs8Z8fP9bMofNtqVRa6QRnRlfeV0quTUqi6Q3Y+678wPH7QDOoyLcvSJocL/zsi/tztpkLJ4kfXink6muAn65QSozsKr0abzgcgAGGhbZcK8ftdw/QxRi+kXi65LYmtz3Xa1bdTzLYKY6Xw6BQlCrYmRgxA=="/>
		<input type="submit"  value="确定">
	</form> -->
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SELECTBANK,
    REMOVEBANK
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
import { Dialog } from 'vant'
Vue.use(Dialog)
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
            activeIcon: process.env.BASE_URL + './statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + './statics/images/inactive.png',
            allPrice: 0, // 可用余额
            type: this.$route.query.type,
            publicPath: process.env.BASE_URL,
            token: null,
            bankList: [],
            selectBank: null, // 已选银行卡
			cash: null , // 提现金额
            tradesman_id: this.$route.query.tradesman_id,
            info: {},
            selectType: this.$route.query.type,
			txTypes:[],
			submitLoading: false,
			is_park: null, // 是否为园区商户 0匠人 1园区 2专家
			showBankPicker: false, // 银行卡选择弹层
			paypwdForm: null, // 设置支付密码表单
        };
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "提现"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                    this.getUserData();
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
            this.getUserData();
		}

		// 融宝回跳
		var routeQuery = this.$route.query;
		var params = {
			merchant_id: routeQuery.merchant_id,
			data: routeQuery.data,
			encryptkey: routeQuery.encryptkey,
			token: this.token
		}
		if (routeQuery.merchant_id && routeQuery.data && routeQuery.encryptkey) {
			console.log('有参数', params)
			var that = this;
			this.$api.park.getparktxjm(params).then(res => {
				console.log(res)
				if (res.code == 200) {
					Dialog.confirm({
						title: '',
						message: '获取融宝返回数据成功',
					})
					.then(() => {
						// on confirm
						that.$router.push(that.$route.path);
					})
					.catch(() => {
						// on cancel
						// console.log('取消')
						that.$router.push(that.$route.path)
					});
					
				} else {
					Dialog.confirm({
						title: '获取融宝返回数据失败',
						message: res.message + '，您可以：<br>&nbsp;&nbsp;1. 点击"确定"重新获取<br>&nbsp;&nbsp;2. 点击"取消"按钮忽略',
					})
					.then(() => {
						// on confirm
						that.$router.push(that.$route.fullPath)
					})
					.catch(() => {
						// on cancel
						// console.log('取消')
						that.$router.push(that.$route.path)
					});
				}
			})
		}
		
    },
    mounted() {
        
    },
    methods: {
        getUserData() {
            var param = {
				token: this.token
            }
            this.$api.park.parkInfo(param).then(res => {
                if (res.code == 200) {
					this.info = res.result.info
					this.allPrice = res.result.usercount.park_money
					// this.is_park = res.result.tid.is_park // 0匠人 1园区 2专家
                    // var list = []
                    // //1商城 2云支付 3城市合伙人4代理商户5用户提现6供应商 
                    // if (this.info.user_money && this.info.user_money > 0) {
                    //     list.push({'name':'匠人余额','money':this.info.user_money,'type':1})
                    // }
                    // if (this.info.seller_money && this.info.seller_money > 0) {
                    //     list.push({'name':'供应商余额','money':this.info.seller_money,'type':6})
                    // }
                    // if (this.info.agent_money && this.info.agent_money > 0) {
                    //     list.push({'name':'分销商余额','money':this.info.agent_money,'type':4})
                    // }
                    // if (this.info.partner_money && this.info.partner_money > 0) {
                    //     list.push({'name':'城市合伙人余额','money':this.info.partner_money,'type':3})
                    // }
                    // this.txTypes = list
                } else {
                    // this.$toast(res.message)
                }
            })
        },
        clickAllPrice() {
            this.cash = this.allPrice
        },
        //提现
        withdraw() {
			this.submitLoading = true
            if (this.cash == null || this.cash == undefined || this.cash == '') {
				this.$toast('请输入提现金额')
				this.submitLoading = false
                return
            }
            if (this.selectBank == null || this.selectBank == undefined || this.selectBank == {} || this.selectBank.id == null || this.selectBank.id == undefined || this.selectBank.id == '') {
				this.$toast('请选择提现银行卡')
				this.submitLoading = false
                return
            }
            var params = {
                token: this.token,
                apply_money: this.cash,
                bank_card_id: this.selectBank.id
			}
			console.log('参数',params)
            this.$api.park.applytx(params).then(res => {
                if (res.code == 200) {
					this.paypwdForm = res.result;
					setTimeout(function () {
						document.querySelector("#paypwdForm form").submit();
					}, 100);
                } else {
					this.$toast(res.message)
					this.submitLoading = false
                }
            })
        },
        // 获取银行卡列表
        getData() {
            var params = {
				token: this.token,
            }
            this.$api.park.banklist(params).then(res => {
                if (res.code == 200) {
                    this.bankList = res.result
                }
            })
		},
		// 页面跳转
		goPage(){
			this.$router.push({
				path: '/single/page',
				query: {
					id: 7 // 7 提现规则
				}
			})
		},
		// 选择卡
		onConfirmBank(e){
			console.log('选择银行卡',e)
			this.selectBank = e
			this.showBankPicker = false
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.img-icon {
    width: 0.53rem;
    height: 0.53rem;
}
/deep/.van-button{
	line-height: normal;
}
</style>
